// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customdirective__total {\n  font-family: \"Roboto\", sans-serif;\n}\n.customdirective__body[style] {\n  padding: 10px;\n  border-radius: 10px;\n  -webkit-transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;\n  transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out;\n}\np.fancyBackground {\n  border-radius: 10px;\n  color: #eee;\n  background-color: deepskyblue;\n}", ""]);
// Exports
module.exports = exports;
